import type { GroundDecalDef } from '@/world-prototype/objects/groundDecal';

/**
 * Hubert backyard ground decals (gravel pads, patio, future paths, mulch, …).
 *
 * Layouts: `layouts.desktop` / `layouts.tablet` / `layouts.mobile`. Flat fields mirror desktop.
 * Updated by World Editor (?edit=1).
 */
const SHARED_GROUND = `${import.meta.env.BASE_URL}art/environments/shared/ground`;
const BACKYARD_GROUND = `${import.meta.env.BASE_URL}art/environments/jacksonville/backyard/ground`;

export const BACKYARD_GROUND_DECAL_DEFS: readonly GroundDecalDef[] = [
  {
    id: "patio",
    title: "Patio",
    enabled: true,
    x: 0.56722,
    y: 0.93045,
    widthFrac: 0.5981,
    rotationDeg: -0.46,
    layouts: {
      desktop: {
        x: 0.56722,
        y: 0.93045,
        widthFrac: 0.5981,
        rotationDeg: -0.46,
        quadCorners: [
          { x: -0.2164, y: -0.0623 },
          { x: 0.2636, y: -0.0641 },
          { x: 0.2986, y: 0.081 },
          { x: -0.2468, y: 0.0728 },
        ],
      },
      tablet: {
        x: 0.55622,
        y: 0.96402,
        widthFrac: 0.62,
        quadCorners: [
          { x: -0.2218, y: -0.0639 },
          { x: 0.2702, y: -0.0657 },
          { x: 0.2966, y: 0.037 },
          { x: -0.2461, y: 0.0355 },
        ],
      },
      mobile: {
        x: 0.55784,
        y: 0.83548,
        widthFrac: 0.62,
        quadCorners: [
          { x: -0.2218, y: -0.0639 },
          { x: 0.2702, y: -0.0657 },
          { x: 0.2966, y: 0.037 },
          { x: -0.2461, y: 0.0355 },
        ],
      },
    },
    quadCorners: [
      { x: -0.2164, y: -0.0623 },
      { x: 0.2636, y: -0.0641 },
      { x: 0.2986, y: 0.081 },
      { x: -0.2468, y: 0.0728 },
    ],
    sprite: {
      src: `${BACKYARD_GROUND}/patio-v1.png`,
      alt: "Concrete patio",
      imageWidth: 1013,
      imageHeight: 130,
    },
    footprint: [],
  },
  {
    id: "gravel-shed-pad",
    title: "Gravel Pad",
    enabled: false,
    x: 0.74886,
    y: 0.68928,
    widthFrac: 0.2007,
    heightFrac: 0.1902,
    rotationDeg: -134.63,
    layouts: {
      desktop: {
        x: 0.74886,
        y: 0.68928,
        widthFrac: 0.2007,
        heightFrac: 0.1902,
        rotationDeg: -134.63,
      },
      tablet: {
        x: 0.96131,
        y: 0.75072,
        widthFrac: 0.3,
        rotationDeg: -127.62,
      },
      mobile: {
        x: 0.96131,
        y: 0.75072,
        widthFrac: 0.3,
        rotationDeg: -127.62,
      },
    },
    sprite: {
      src: `${SHARED_GROUND}/gravel-pad.png`,
      alt: "Gravel utility pad",
      imageWidth: 1200,
      imageHeight: 640,
    },
    footprint: [],
  },
  {
    id: "gravel-shed-pad-2",
    title: "Gravel Pad",
    enabled: true,
    x: 0.92531,
    y: 0.71075,
    widthFrac: 0.2151,
    heightFrac: 0.2572,
    rotationDeg: -132.24,
    layouts: {
      desktop: {
        x: 0.92531,
        y: 0.71075,
        widthFrac: 0.2151,
        heightFrac: 0.2572,
        rotationDeg: -132.24,
      },
      tablet: {
        x: 0.93339,
        y: 0.6999,
        widthFrac: 0.1919,
        heightFrac: 0.2562,
        rotationDeg: -130.92,
      },
      mobile: {
        x: 0.93339,
        y: 0.6999,
        widthFrac: 0.1919,
        heightFrac: 0.2562,
        rotationDeg: -130.92,
      },
    },
    sprite: {
      src: `${SHARED_GROUND}/gravel-pad.png`,
      alt: "Gravel utility pad",
      imageWidth: 1200,
      imageHeight: 640,
    },
    footprint: [],
  },
];
